<div 
  [formGroup]="form()"
  class="more__terms-form-field"
>
  <label class="terms-form-field__label ci-paragraph-p1-semibold">
    <input 
      class="terms-form-field__checkbox"
      type="checkbox" 
      [formControlName]="formControlName()" 
    />
    {{ 'He leído y acepto los términos y condiciones de uso' | translate }}*

  </label>

  <section class="policy-text">
    <strong class="blue">{{'Responsable del tratamiento' | translate}}:</strong> {{'Empresa Municipal de Transportes de Madrid, S.A' | translate}}. (“<strong>EMT”</strong>).<br>
    <strong class="blue">{{'Finalidades' | translate}}:</strong> {{'Facilitar a los usuarios rutas y lugares de interés a visitar en la ciudad de Madrid según las preferencias indicadas' | translate}}.<br>
    <strong class="blue">{{'Derechos' | translate}}:</strong> {{'Puede consultar la información ampliada y cómo ejercitar sus derechos en este' | translate}} <a href="https://www.emtmadrid.es/privacidad/turismoInteligente.aspx" target="_blank">{{'link' | translate}}</a><br>
</section>

</div>

